var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { mutationTypes } from './mutations';
import { container } from 'tsyringe';
import { FormResponseRepository } from 'packages/form/entities/legacy/FormResponseRepository';
import { JobRepository } from 'packages/jobs/JobRepository';
var retrievedJobs = {};
var promise = null;
export var actions = {
    getFormResponsesForTalent: function (_a, _b) {
        var commit = _a.commit, state = _a.state;
        var talentId = _b.talentId, _c = _b.pagination, pagination = _c === void 0 ? null : _c, _d = _b.jobId, jobId = _d === void 0 ? null : _d;
        return __awaiter(this, void 0, void 0, function () {
            var jobRepository;
            return __generator(this, function (_e) {
                if (promise) {
                    promise.cancel();
                }
                jobRepository = container.resolve(JobRepository);
                commit(mutationTypes.SET_LOADING, true);
                promise = container.resolve(FormResponseRepository).listForTalent(talentId, pagination, jobId)
                    .then(function (response) { return Promise.all(Array.from(new Set(response.items
                    .map(function (res) { return res.jobId; })
                    .filter(function (jobId) { return jobId !== null; })))
                    .map(function (jobId) { return jobRepository.find(jobId).catch(function () { return null; }); }))
                    .then(function (jobs) {
                    jobs.forEach(function (job) {
                        if (job) {
                            retrievedJobs["" + job.id] = job;
                        }
                    });
                    response.items.forEach(function (item) { var _a; return item.job = (_a = retrievedJobs[item.jobId]) !== null && _a !== void 0 ? _a : null; });
                    return response;
                }); });
                promise.then(function (response) {
                    response.items.concat(response.items.filter(function (newResponse) {
                        return !state.formResponses.some(function (existingResponse) { return existingResponse.id === newResponse.id; });
                    }));
                    commit(mutationTypes.SET_FORM_RESPONSES, response.items);
                    commit(mutationTypes.SET_PAGINATION_RESPONSE, response.pagination);
                }).finally(function () {
                    commit(mutationTypes.SET_LOADING, false);
                });
                return [2 /*return*/];
            });
        });
    },
};
